import { createUnleash } from 'shared/unleash/hook';
import { UnleashToggles } from '@/domain';

const { UnleashProvider, useUnleash } = createUnleash<UnleashToggles>();

export { UnleashProvider, useUnleash };
